import { render, staticRenderFns } from "./Warehouse.vue?vue&type=template&id=5d155985&"
import script from "./Warehouse.vue?vue&type=script&lang=js&"
export * from "./Warehouse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports